module.exports = __webpack_public_path__ + "static/media/4.e60ded5e.png";